import EtiquetaAzulBusqueda from "../EtiquetaAzulBusqueda/EtiquetaAzulBusqueda";
import {
  ModalVerificaOsBody,
  ModalVerificaOsContainer,
  ModalVerificaOsFooter,
} from "./localStyle";

const ModalVerificaOs = ({
  data,
  onClick,
  onClickCancelar,
  btnAceptarStr,
  strDescripcion,
  prestacion,
  fullStr,
}) => {
  const dtoPrestacion = { GruposMedico: [prestacion] };
  return (
    <ModalVerificaOsContainer>
      {prestacion && (
        <EtiquetaAzulBusqueda fullStr={fullStr} dtoPrestacion={dtoPrestacion} />
      )}
      <ModalVerificaOsBody>
        <span>{strDescripcion ? strDescripcion : data.mensaje}</span>
      </ModalVerificaOsBody>
      <ModalVerificaOsFooter>
        <div
          className="ModalVerificaOs-btn ModalVerificaOs-white"
          onClick={onClickCancelar}
        >
          Cancelar
        </div>
        <div
          className="ModalVerificaOs-btn ModalVerificaOs-latex10"
          onClick={onClick}
        >
          {btnAceptarStr}
        </div>
      </ModalVerificaOsFooter>
    </ModalVerificaOsContainer>
  );
};

export default ModalVerificaOs;
